export const ENROLLMENT_RESET_VERIFY_PHONE = 'ENROLLMENT_RESET_VERIFY_PHONE';

export const enrollmentResetVerifyPhone = () => dispatch =>
  dispatch({
    type: ENROLLMENT_RESET_VERIFY_PHONE,
  });
